export const GLOBAL_PROGRAM_RESET_STATE = 'GLOBAL_PROGRAM_RESET_STATE';
export const GLOBAL_PROGRAM_CURRENT_ITEM = 'GLOBAL_PROGRAM_CURRENT_ITEM';

export const GLOBAL_PROGRAM_REQUEST_LOADING = 'GLOBAL_PROGRAM_REQUEST_LOADING';
export const GLOBAL_PROGRAM_REQUEST_SUCCESS = 'GLOBAL_PROGRAM_REQUEST_SUCCESS';
export const GLOBAL_PROGRAM_REQUEST_FAILED = 'GLOBAL_PROGRAM_REQUEST_FAILED';

export const GLOBAL_PROGRAM_CURRENT_ACTION = 'GLOBAL_PROGRAM_CURRENT_ACTION';
export const GLOBAL_PROGRAM_RESET_ACTION = 'GLOBAL_PROGRAM_RESET_ACTION';